import type { CountryInfo, RegionConfig, StatItem } from './GlobalCoverageSection.types';

export const COVERED_COUNTRIES: Record<string, CountryInfo> = {
  // Europe
  '8': { name: 'Albania', region: 'Europe', alpha2: 'al', linkages: 18400 },
  '20': { name: 'Andorra', region: 'Europe', alpha2: 'ad', linkages: 4200 },
  '40': { name: 'Austria', region: 'Europe', alpha2: 'at', linkages: 312000 },
  '112': { name: 'Belarus', region: 'Europe', alpha2: 'by', linkages: 67000 },
  '56': { name: 'Belgium', region: 'Europe', alpha2: 'be', linkages: 487000 },
  '70': { name: 'Bosnia and Herzegovina', region: 'Europe', alpha2: 'ba', linkages: 21000 },
  '100': { name: 'Bulgaria', region: 'Europe', alpha2: 'bg', linkages: 94000 },
  '191': { name: 'Croatia', region: 'Europe', alpha2: 'hr', linkages: 78000 },
  '196': { name: 'Cyprus', region: 'Europe', alpha2: 'cy', linkages: 142000 },
  '203': { name: 'Czech Republic', region: 'Europe', alpha2: 'cz', linkages: 268000 },
  '208': { name: 'Denmark', region: 'Europe', alpha2: 'dk', linkages: 391000 },
  '233': { name: 'Estonia', region: 'Europe', alpha2: 'ee', linkages: 84000 },
  '246': { name: 'Finland', region: 'Europe', alpha2: 'fi', linkages: 223000 },
  '250': { name: 'France', region: 'Europe', alpha2: 'fr', linkages: 2140000 },
  '276': { name: 'Germany', region: 'Europe', alpha2: 'de', linkages: 3280000 },
  '300': { name: 'Greece', region: 'Europe', alpha2: 'gr', linkages: 156000 },
  '348': { name: 'Hungary', region: 'Europe', alpha2: 'hu', linkages: 189000 },
  '352': { name: 'Iceland', region: 'Europe', alpha2: 'is', linkages: 31000 },
  '372': { name: 'Ireland', region: 'Europe', alpha2: 'ie', linkages: 378000 },
  '380': { name: 'Italy', region: 'Europe', alpha2: 'it', linkages: 1920000 },
  '428': { name: 'Latvia', region: 'Europe', alpha2: 'lv', linkages: 72000 },
  '438': { name: 'Liechtenstein', region: 'Europe', alpha2: 'li', linkages: 18000 },
  '440': { name: 'Lithuania', region: 'Europe', alpha2: 'lt', linkages: 81000 },
  '442': { name: 'Luxembourg', region: 'Europe', alpha2: 'lu', linkages: 214000 },
  '470': { name: 'Malta', region: 'Europe', alpha2: 'mt', linkages: 67000 },
  '498': { name: 'Moldova', region: 'Europe', alpha2: 'md', linkages: 24000 },
  '492': { name: 'Monaco', region: 'Europe', alpha2: 'mc', linkages: 38000 },
  '499': { name: 'Montenegro', region: 'Europe', alpha2: 'me', linkages: 12000 },
  '528': { name: 'Netherlands', region: 'Europe', alpha2: 'nl', linkages: 892000 },
  '807': { name: 'North Macedonia', region: 'Europe', alpha2: 'mk', linkages: 19000 },
  '578': { name: 'Norway', region: 'Europe', alpha2: 'no', linkages: 418000 },
  '616': { name: 'Poland', region: 'Europe', alpha2: 'pl', linkages: 678000 },
  '620': { name: 'Portugal', region: 'Europe', alpha2: 'pt', linkages: 312000 },
  '642': { name: 'Romania', region: 'Europe', alpha2: 'ro', linkages: 241000 },
  '643': { name: 'Russia', region: 'Europe', alpha2: 'ru', linkages: 1480000 },
  '674': { name: 'San Marino', region: 'Europe', alpha2: 'sm', linkages: 6800 },
  '688': { name: 'Serbia', region: 'Europe', alpha2: 'rs', linkages: 84000 },
  '703': { name: 'Slovakia', region: 'Europe', alpha2: 'sk', linkages: 134000 },
  '705': { name: 'Slovenia', region: 'Europe', alpha2: 'si', linkages: 74000 },
  '724': { name: 'Spain', region: 'Europe', alpha2: 'es', linkages: 1560000 },
  '752': { name: 'Sweden', region: 'Europe', alpha2: 'se', linkages: 624000 },
  '756': { name: 'Switzerland', region: 'Europe', alpha2: 'ch', linkages: 548000 },
  '804': { name: 'Ukraine', region: 'Europe', alpha2: 'ua', linkages: 312000 },
  '826': { name: 'United Kingdom', region: 'Europe', alpha2: 'gb', linkages: 4120000 },

  // Asia
  '4': { name: 'Afghanistan', region: 'Asia', alpha2: 'af', linkages: 8200 },
  '51': { name: 'Armenia', region: 'Asia', alpha2: 'am', linkages: 22000 },
  '31': { name: 'Azerbaijan', region: 'Asia', alpha2: 'az', linkages: 34000 },
  '48': { name: 'Bahrain', region: 'Asia', alpha2: 'bh', linkages: 48000 },
  '50': { name: 'Bangladesh', region: 'Asia', alpha2: 'bd', linkages: 94000 },
  '64': { name: 'Bhutan', region: 'Asia', alpha2: 'bt', linkages: 4100 },
  '96': { name: 'Brunei', region: 'Asia', alpha2: 'bn', linkages: 9800 },
  '116': { name: 'Cambodia', region: 'Asia', alpha2: 'kh', linkages: 18000 },
  '156': { name: 'China', region: 'Asia', alpha2: 'cn', linkages: 4800000 },
  '268': { name: 'Georgia', region: 'Asia', alpha2: 'ge', linkages: 38000 },
  '356': { name: 'India', region: 'Asia', alpha2: 'in', linkages: 2140000 },
  '360': { name: 'Indonesia', region: 'Asia', alpha2: 'id', linkages: 312000 },
  '364': { name: 'Iran', region: 'Asia', alpha2: 'ir', linkages: 142000 },
  '368': { name: 'Iraq', region: 'Asia', alpha2: 'iq', linkages: 38000 },
  '376': { name: 'Israel', region: 'Asia', alpha2: 'il', linkages: 218000 },
  '392': { name: 'Japan', region: 'Asia', alpha2: 'jp', linkages: 2680000 },
  '400': { name: 'Jordan', region: 'Asia', alpha2: 'jo', linkages: 42000 },
  '398': { name: 'Kazakhstan', region: 'Asia', alpha2: 'kz', linkages: 118000 },
  '414': { name: 'Kuwait', region: 'Asia', alpha2: 'kw', linkages: 62000 },
  '417': { name: 'Kyrgyzstan', region: 'Asia', alpha2: 'kg', linkages: 14000 },
  '418': { name: 'Laos', region: 'Asia', alpha2: 'la', linkages: 8400 },
  '422': { name: 'Lebanon', region: 'Asia', alpha2: 'lb', linkages: 34000 },
  '458': { name: 'Malaysia', region: 'Asia', alpha2: 'my', linkages: 284000 },
  '462': { name: 'Maldives', region: 'Asia', alpha2: 'mv', linkages: 6200 },
  '496': { name: 'Mongolia', region: 'Asia', alpha2: 'mn', linkages: 14000 },
  '104': { name: 'Myanmar', region: 'Asia', alpha2: 'mm', linkages: 28000 },
  '524': { name: 'Nepal', region: 'Asia', alpha2: 'np', linkages: 18000 },
  '512': { name: 'Oman', region: 'Asia', alpha2: 'om', linkages: 54000 },
  '586': { name: 'Pakistan', region: 'Asia', alpha2: 'pk', linkages: 124000 },
  '275': { name: 'Palestine', region: 'Asia', alpha2: 'ps', linkages: 8600 },
  '608': { name: 'Philippines', region: 'Asia', alpha2: 'ph', linkages: 178000 },
  '634': { name: 'Qatar', region: 'Asia', alpha2: 'qa', linkages: 78000 },
  '682': { name: 'Saudi Arabia', region: 'Asia', alpha2: 'sa', linkages: 312000 },
  '702': { name: 'Singapore', region: 'Asia', alpha2: 'sg', linkages: 468000 },
  '410': { name: 'South Korea', region: 'Asia', alpha2: 'kr', linkages: 892000 },
  '144': { name: 'Sri Lanka', region: 'Asia', alpha2: 'lk', linkages: 38000 },
  '760': { name: 'Syria', region: 'Asia', alpha2: 'sy', linkages: 12000 },
  '158': { name: 'Taiwan', region: 'Asia', alpha2: 'tw', linkages: 348000 },
  '762': { name: 'Tajikistan', region: 'Asia', alpha2: 'tj', linkages: 9400 },
  '764': { name: 'Thailand', region: 'Asia', alpha2: 'th', linkages: 248000 },
  '626': { name: 'Timor-Leste', region: 'Asia', alpha2: 'tl', linkages: 3200 },
  '792': { name: 'Turkey', region: 'Asia', alpha2: 'tr', linkages: 542000 },
  '795': { name: 'Turkmenistan', region: 'Asia', alpha2: 'tm', linkages: 8800 },
  '784': { name: 'United Arab Emirates', region: 'Asia', alpha2: 'ae', linkages: 384000 },
  '860': { name: 'Uzbekistan', region: 'Asia', alpha2: 'uz', linkages: 42000 },
  '704': { name: 'Vietnam', region: 'Asia', alpha2: 'vn', linkages: 168000 },
  '887': { name: 'Yemen', region: 'Asia', alpha2: 'ye', linkages: 12000 },

  // Africa
  '12': { name: 'Algeria', region: 'Africa', alpha2: 'dz', linkages: 68000 },
  '24': { name: 'Angola', region: 'Africa', alpha2: 'ao', linkages: 24000 },
  '204': { name: 'Benin', region: 'Africa', alpha2: 'bj', linkages: 8400 },
  '72': { name: 'Botswana', region: 'Africa', alpha2: 'bw', linkages: 14000 },
  '854': { name: 'Burkina Faso', region: 'Africa', alpha2: 'bf', linkages: 6800 },
  '108': { name: 'Burundi', region: 'Africa', alpha2: 'bi', linkages: 3800 },
  '132': { name: 'Cabo Verde', region: 'Africa', alpha2: 'cv', linkages: 4200 },
  '120': { name: 'Cameroon', region: 'Africa', alpha2: 'cm', linkages: 18000 },
  '140': { name: 'Central African Republic', region: 'Africa', alpha2: 'cf', linkages: 2400 },
  '148': { name: 'Chad', region: 'Africa', alpha2: 'td', linkages: 4800 },
  '174': { name: 'Comoros', region: 'Africa', alpha2: 'km', linkages: 1800 },
  '178': { name: 'Republic of Congo', region: 'Africa', alpha2: 'cg', linkages: 6200 },
  '180': { name: 'DR Congo', region: 'Africa', alpha2: 'cd', linkages: 14000 },
  '262': { name: 'Djibouti', region: 'Africa', alpha2: 'dj', linkages: 3400 },
  '818': { name: 'Egypt', region: 'Africa', alpha2: 'eg', linkages: 124000 },
  '226': { name: 'Equatorial Guinea', region: 'Africa', alpha2: 'gq', linkages: 4800 },
  '232': { name: 'Eritrea', region: 'Africa', alpha2: 'er', linkages: 2200 },
  '748': { name: 'Eswatini', region: 'Africa', alpha2: 'sz', linkages: 4600 },
  '231': { name: 'Ethiopia', region: 'Africa', alpha2: 'et', linkages: 22000 },
  '266': { name: 'Gabon', region: 'Africa', alpha2: 'ga', linkages: 8200 },
  '270': { name: 'Gambia', region: 'Africa', alpha2: 'gm', linkages: 3600 },
  '288': { name: 'Ghana', region: 'Africa', alpha2: 'gh', linkages: 34000 },
  '324': { name: 'Guinea', region: 'Africa', alpha2: 'gn', linkages: 6400 },
  '624': { name: 'Guinea-Bissau', region: 'Africa', alpha2: 'gw', linkages: 2800 },
  '384': { name: "Côte d'Ivoire", region: 'Africa', alpha2: 'ci', linkages: 18000 },
  '404': { name: 'Kenya', region: 'Africa', alpha2: 'ke', linkages: 54000 },
  '426': { name: 'Lesotho', region: 'Africa', alpha2: 'ls', linkages: 3200 },
  '430': { name: 'Liberia', region: 'Africa', alpha2: 'lr', linkages: 4800 },
  '434': { name: 'Libya', region: 'Africa', alpha2: 'ly', linkages: 14000 },
  '450': { name: 'Madagascar', region: 'Africa', alpha2: 'mg', linkages: 8600 },
  '454': { name: 'Malawi', region: 'Africa', alpha2: 'mw', linkages: 6200 },
  '466': { name: 'Mali', region: 'Africa', alpha2: 'ml', linkages: 7800 },
  '478': { name: 'Mauritania', region: 'Africa', alpha2: 'mr', linkages: 5400 },
  '480': { name: 'Mauritius', region: 'Africa', alpha2: 'mu', linkages: 38000 },
  '504': { name: 'Morocco', region: 'Africa', alpha2: 'ma', linkages: 84000 },
  '508': { name: 'Mozambique', region: 'Africa', alpha2: 'mz', linkages: 12000 },
  '516': { name: 'Namibia', region: 'Africa', alpha2: 'na', linkages: 14000 },
  '562': { name: 'Niger', region: 'Africa', alpha2: 'ne', linkages: 4600 },
  '566': { name: 'Nigeria', region: 'Africa', alpha2: 'ng', linkages: 98000 },
  '646': { name: 'Rwanda', region: 'Africa', alpha2: 'rw', linkages: 12000 },
  '678': { name: 'São Tomé and Príncipe', region: 'Africa', alpha2: 'st', linkages: 1600 },
  '686': { name: 'Senegal', region: 'Africa', alpha2: 'sn', linkages: 16000 },
  '690': { name: 'Seychelles', region: 'Africa', alpha2: 'sc', linkages: 12000 },
  '694': { name: 'Sierra Leone', region: 'Africa', alpha2: 'sl', linkages: 4200 },
  '706': { name: 'Somalia', region: 'Africa', alpha2: 'so', linkages: 3800 },
  '710': { name: 'South Africa', region: 'Africa', alpha2: 'za', linkages: 248000 },
  '728': { name: 'South Sudan', region: 'Africa', alpha2: 'ss', linkages: 4200 },
  '729': { name: 'Sudan', region: 'Africa', alpha2: 'sd', linkages: 14000 },
  '834': { name: 'Tanzania', region: 'Africa', alpha2: 'tz', linkages: 28000 },
  '768': { name: 'Togo', region: 'Africa', alpha2: 'tg', linkages: 6800 },
  '788': { name: 'Tunisia', region: 'Africa', alpha2: 'tn', linkages: 42000 },
  '800': { name: 'Uganda', region: 'Africa', alpha2: 'ug', linkages: 18000 },
  '894': { name: 'Zambia', region: 'Africa', alpha2: 'zm', linkages: 14000 },
  '716': { name: 'Zimbabwe', region: 'Africa', alpha2: 'zw', linkages: 12000 },

  // North America
  '124': { name: 'Canada', region: 'North America', alpha2: 'ca', linkages: 1840000 },
  '484': { name: 'Mexico', region: 'North America', alpha2: 'mx', linkages: 412000 },
  '840': { name: 'United States', region: 'North America', alpha2: 'us', linkages: 6240000 },

  // Central America
  '84': { name: 'Belize', region: 'Central America', alpha2: 'bz', linkages: 8400 },
  '188': { name: 'Costa Rica', region: 'Central America', alpha2: 'cr', linkages: 34000 },
  '222': { name: 'El Salvador', region: 'Central America', alpha2: 'sv', linkages: 18000 },
  '320': { name: 'Guatemala', region: 'Central America', alpha2: 'gt', linkages: 24000 },
  '340': { name: 'Honduras', region: 'Central America', alpha2: 'hn', linkages: 14000 },
  '558': { name: 'Nicaragua', region: 'Central America', alpha2: 'ni', linkages: 12000 },
  '591': { name: 'Panama', region: 'Central America', alpha2: 'pa', linkages: 84000 },

  // Caribbean
  '28': { name: 'Antigua and Barbuda', region: 'Caribbean', alpha2: 'ag', linkages: 9200 },
  '44': { name: 'Bahamas', region: 'Caribbean', alpha2: 'bs', linkages: 28000 },
  '52': { name: 'Barbados', region: 'Caribbean', alpha2: 'bb', linkages: 18000 },
  '192': { name: 'Cuba', region: 'Caribbean', alpha2: 'cu', linkages: 12000 },
  '212': { name: 'Dominica', region: 'Caribbean', alpha2: 'dm', linkages: 4800 },
  '214': { name: 'Dominican Republic', region: 'Caribbean', alpha2: 'do', linkages: 28000 },
  '308': { name: 'Grenada', region: 'Caribbean', alpha2: 'gd', linkages: 4200 },
  '332': { name: 'Haiti', region: 'Caribbean', alpha2: 'ht', linkages: 6800 },
  '388': { name: 'Jamaica', region: 'Caribbean', alpha2: 'jm', linkages: 22000 },
  '659': { name: 'Saint Kitts and Nevis', region: 'Caribbean', alpha2: 'kn', linkages: 6400 },
  '662': { name: 'Saint Lucia', region: 'Caribbean', alpha2: 'lc', linkages: 7200 },
  '670': { name: 'Saint Vincent and the Grenadines', region: 'Caribbean', alpha2: 'vc', linkages: 4800 },
  '780': { name: 'Trinidad and Tobago', region: 'Caribbean', alpha2: 'tt', linkages: 24000 },

  // South America
  '32': { name: 'Argentina', region: 'South America', alpha2: 'ar', linkages: 312000 },
  '68': { name: 'Bolivia', region: 'South America', alpha2: 'bo', linkages: 28000 },
  '76': { name: 'Brazil', region: 'South America', alpha2: 'br', linkages: 1240000 },
  '152': { name: 'Chile', region: 'South America', alpha2: 'cl', linkages: 168000 },
  '170': { name: 'Colombia', region: 'South America', alpha2: 'co', linkages: 184000 },
  '218': { name: 'Ecuador', region: 'South America', alpha2: 'ec', linkages: 58000 },
  '328': { name: 'Guyana', region: 'South America', alpha2: 'gy', linkages: 8400 },
  '600': { name: 'Paraguay', region: 'South America', alpha2: 'py', linkages: 18000 },
  '604': { name: 'Peru', region: 'South America', alpha2: 'pe', linkages: 84000 },
  '740': { name: 'Suriname', region: 'South America', alpha2: 'sr', linkages: 6800 },
  '858': { name: 'Uruguay', region: 'South America', alpha2: 'uy', linkages: 42000 },
  '862': { name: 'Venezuela', region: 'South America', alpha2: 've', linkages: 48000 },

  // Oceania
  '36': { name: 'Australia', region: 'Oceania', alpha2: 'au', linkages: 892000 },
  '242': { name: 'Fiji', region: 'Oceania', alpha2: 'fj', linkages: 8400 },
  '296': { name: 'Kiribati', region: 'Oceania', alpha2: 'ki', linkages: 1200 },
  '584': { name: 'Marshall Islands', region: 'Oceania', alpha2: 'mh', linkages: 3400 },
  '583': { name: 'Micronesia', region: 'Oceania', alpha2: 'fm', linkages: 1800 },
  '520': { name: 'Nauru', region: 'Oceania', alpha2: 'nr', linkages: 800 },
  '554': { name: 'New Zealand', region: 'Oceania', alpha2: 'nz', linkages: 248000 },
  '585': { name: 'Palau', region: 'Oceania', alpha2: 'pw', linkages: 2400 },
  '598': { name: 'Papua New Guinea', region: 'Oceania', alpha2: 'pg', linkages: 12000 },
  '882': { name: 'Samoa', region: 'Oceania', alpha2: 'ws', linkages: 3800 },
  '90': { name: 'Solomon Islands', region: 'Oceania', alpha2: 'sb', linkages: 2800 },
  '776': { name: 'Tonga', region: 'Oceania', alpha2: 'to', linkages: 2200 },
  '798': { name: 'Tuvalu', region: 'Oceania', alpha2: 'tv', linkages: 600 },
  '548': { name: 'Vanuatu', region: 'Oceania', alpha2: 'vu', linkages: 4200 },
};

// Q2 2026 — actual company counts from Global Database registry
export const COVERED_COUNTRIES_Q2_2026: Record<string, CountryInfo> = {
  // Europe
  '250': { name: 'France', region: 'Europe', alpha2: 'fr', linkages: 37888022 },
  '826': { name: 'United Kingdom', region: 'Europe', alpha2: 'gb', linkages: 18174868 },
  '380': { name: 'Italy', region: 'Europe', alpha2: 'it', linkages: 10284453 },
  '724': { name: 'Spain', region: 'Europe', alpha2: 'es', linkages: 4701383 },
  '528': { name: 'Netherlands', region: 'Europe', alpha2: 'nl', linkages: 7368217 },
  '578': { name: 'Norway', region: 'Europe', alpha2: 'no', linkages: 5104944 },
  '56': { name: 'Belgium', region: 'Europe', alpha2: 'be', linkages: 3934181 },
  '276': { name: 'Germany', region: 'Europe', alpha2: 'de', linkages: 4571977 },
  '643': { name: 'Russia', region: 'Europe', alpha2: 'ru', linkages: 2411433 },
  '642': { name: 'Romania', region: 'Europe', alpha2: 'ro', linkages: 4144543 },
  '804': { name: 'Ukraine', region: 'Europe', alpha2: 'ua', linkages: 1714671 },
  '752': { name: 'Sweden', region: 'Europe', alpha2: 'se', linkages: 2837229 },
  '246': { name: 'Finland', region: 'Europe', alpha2: 'fi', linkages: 1662670 },
  '300': { name: 'Greece', region: 'Europe', alpha2: 'gr', linkages: 1601195 },
  '203': { name: 'Czechia', region: 'Europe', alpha2: 'cz', linkages: 1015908 },
  '208': { name: 'Denmark', region: 'Europe', alpha2: 'dk', linkages: 2232855 },
  '616': { name: 'Poland', region: 'Europe', alpha2: 'pl', linkages: 876207 },
  '620': { name: 'Portugal', region: 'Europe', alpha2: 'pt', linkages: 728138 },
  '756': { name: 'Switzerland', region: 'Europe', alpha2: 'ch', linkages: 988838 },
  '348': { name: 'Hungary', region: 'Europe', alpha2: 'hu', linkages: 1320306 },
  '100': { name: 'Bulgaria', region: 'Europe', alpha2: 'bg', linkages: 422498 },
  '233': { name: 'Estonia', region: 'Europe', alpha2: 'ee', linkages: 451151 },
  '40': { name: 'Austria', region: 'Europe', alpha2: 'at', linkages: 635165 },
  '372': { name: 'Ireland', region: 'Europe', alpha2: 'ie', linkages: 813247 },
  '705': { name: 'Slovenia', region: 'Europe', alpha2: 'si', linkages: 297409 },
  '196': { name: 'Cyprus', region: 'Europe', alpha2: 'cy', linkages: 560594 },
  '191': { name: 'Croatia', region: 'Europe', alpha2: 'hr', linkages: 239452 },
  '440': { name: 'Lithuania', region: 'Europe', alpha2: 'lt', linkages: 370062 },
  '428': { name: 'Latvia', region: 'Europe', alpha2: 'lv', linkages: 469064 },
  '442': { name: 'Luxembourg', region: 'Europe', alpha2: 'lu', linkages: 324858 },
  '498': { name: 'Moldova', region: 'Europe', alpha2: 'md', linkages: 284279 },
  '688': { name: 'Serbia', region: 'Europe', alpha2: 'rs', linkages: 622853 },
  '703': { name: 'Slovakia', region: 'Europe', alpha2: 'sk', linkages: 27088 },
  '112': { name: 'Belarus', region: 'Europe', alpha2: 'by', linkages: 26735 },
  '470': { name: 'Malta', region: 'Europe', alpha2: 'mt', linkages: 61559 },
  '31': { name: 'Azerbaijan', region: 'Europe', alpha2: 'az', linkages: 6526 },
  '51': { name: 'Armenia', region: 'Europe', alpha2: 'am', linkages: 3402 },
  '492': { name: 'Monaco', region: 'Europe', alpha2: 'mc', linkages: 2193 },
  '268': { name: 'Georgia', region: 'Europe', alpha2: 'ge', linkages: 2005 },
  '70': { name: 'Bosnia and Herzegovina', region: 'Europe', alpha2: 'ba', linkages: 1311 },
  '8': { name: 'Albania', region: 'Europe', alpha2: 'al', linkages: 1259 },
  '807': { name: 'North Macedonia', region: 'Europe', alpha2: 'mk', linkages: 1210 },
  '674': { name: 'San Marino', region: 'Europe', alpha2: 'sm', linkages: 450 },
  '352': { name: 'Iceland', region: 'Europe', alpha2: 'is', linkages: 282 },
  '499': { name: 'Montenegro', region: 'Europe', alpha2: 'me', linkages: 53 },
  '438': { name: 'Liechtenstein', region: 'Europe', alpha2: 'li', linkages: 40 },

  // Asia
  '392': { name: 'Japan', region: 'Asia', alpha2: 'jp', linkages: 5776359 },
  '356': { name: 'India', region: 'Asia', alpha2: 'in', linkages: 2593547 },
  '344': { name: 'Hong Kong', region: 'Asia', alpha2: 'hk', linkages: 3785281 },
  '158': { name: 'Taiwan', region: 'Asia', alpha2: 'tw', linkages: 1041735 },
  '702': { name: 'Singapore', region: 'Asia', alpha2: 'sg', linkages: 2088126 },
  '398': { name: 'Kazakhstan', region: 'Asia', alpha2: 'kz', linkages: 534777 },
  '376': { name: 'Israel', region: 'Asia', alpha2: 'il', linkages: 733013 },
  '784': { name: 'United Arab Emirates', region: 'Asia', alpha2: 'ae', linkages: 584644 },
  '156': { name: 'China', region: 'Asia', alpha2: 'cn', linkages: 197345 },
  '792': { name: 'Turkey', region: 'Asia', alpha2: 'tr', linkages: 81388 },
  '682': { name: 'Saudi Arabia', region: 'Asia', alpha2: 'sa', linkages: 65617 },
  '458': { name: 'Malaysia', region: 'Asia', alpha2: 'my', linkages: 62269 },
  '634': { name: 'Qatar', region: 'Asia', alpha2: 'qa', linkages: 55347 },
  '704': { name: 'Vietnam', region: 'Asia', alpha2: 'vn', linkages: 55256 },
  '608': { name: 'Philippines', region: 'Asia', alpha2: 'ph', linkages: 46485 },
  '360': { name: 'Indonesia', region: 'Asia', alpha2: 'id', linkages: 42267 },
  '764': { name: 'Thailand', region: 'Asia', alpha2: 'th', linkages: 32478 },
  '410': { name: 'South Korea', region: 'Asia', alpha2: 'kr', linkages: 29596 },
  '364': { name: 'Iran', region: 'Asia', alpha2: 'ir', linkages: 29364 },
  '422': { name: 'Lebanon', region: 'Asia', alpha2: 'lb', linkages: 24242 },
  '414': { name: 'Kuwait', region: 'Asia', alpha2: 'kw', linkages: 16357 },
  '144': { name: 'Sri Lanka', region: 'Asia', alpha2: 'lk', linkages: 9119 },
  '512': { name: 'Oman', region: 'Asia', alpha2: 'om', linkages: 7844 },
  '417': { name: 'Kyrgyzstan', region: 'Asia', alpha2: 'kg', linkages: 6876 },
  '48': { name: 'Bahrain', region: 'Asia', alpha2: 'bh', linkages: 4954 },
  '400': { name: 'Jordan', region: 'Asia', alpha2: 'jo', linkages: 3317 },
  '116': { name: 'Cambodia', region: 'Asia', alpha2: 'kh', linkages: 1460 },
  '368': { name: 'Iraq', region: 'Asia', alpha2: 'iq', linkages: 1277 },
  '586': { name: 'Pakistan', region: 'Asia', alpha2: 'pk', linkages: 1160 },
  '50': { name: 'Bangladesh', region: 'Asia', alpha2: 'bd', linkages: 927 },
  '104': { name: 'Myanmar', region: 'Asia', alpha2: 'mm', linkages: 388 },
  '4': { name: 'Afghanistan', region: 'Asia', alpha2: 'af', linkages: 264 },
  '462': { name: 'Maldives', region: 'Asia', alpha2: 'mv', linkages: 234 },
  '524': { name: 'Nepal', region: 'Asia', alpha2: 'np', linkages: 188 },
  '760': { name: 'Syria', region: 'Asia', alpha2: 'sy', linkages: 89 },
  '418': { name: 'Laos', region: 'Asia', alpha2: 'la', linkages: 77 },
  '496': { name: 'Mongolia', region: 'Asia', alpha2: 'mn', linkages: 68 },
  '887': { name: 'Yemen', region: 'Asia', alpha2: 'ye', linkages: 61 },
  '860': { name: 'Uzbekistan', region: 'Asia', alpha2: 'uz', linkages: 58 },
  '762': { name: 'Tajikistan', region: 'Asia', alpha2: 'tj', linkages: 34 },
  '795': { name: 'Turkmenistan', region: 'Asia', alpha2: 'tm', linkages: 23 },
  '64': { name: 'Bhutan', region: 'Asia', alpha2: 'bt', linkages: 16 },
  '96': { name: 'Brunei', region: 'Asia', alpha2: 'bn', linkages: 14 },

  // Africa
  '566': { name: 'Nigeria', region: 'Africa', alpha2: 'ng', linkages: 156183 },
  '710': { name: 'South Africa', region: 'Africa', alpha2: 'za', linkages: 130959 },
  '404': { name: 'Kenya', region: 'Africa', alpha2: 'ke', linkages: 91963 },
  '818': { name: 'Egypt', region: 'Africa', alpha2: 'eg', linkages: 73323 },
  '834': { name: 'Tanzania', region: 'Africa', alpha2: 'tz', linkages: 45519 },
  '504': { name: 'Morocco', region: 'Africa', alpha2: 'ma', linkages: 40431 },
  '788': { name: 'Tunisia', region: 'Africa', alpha2: 'tn', linkages: 38529 },
  '800': { name: 'Uganda', region: 'Africa', alpha2: 'ug', linkages: 38411 },
  '12': { name: 'Algeria', region: 'Africa', alpha2: 'dz', linkages: 31119 },
  '384': { name: "Côte d'Ivoire", region: 'Africa', alpha2: 'ci', linkages: 28549 },
  '480': { name: 'Mauritius', region: 'Africa', alpha2: 'mu', linkages: 16466 },
  '288': { name: 'Ghana', region: 'Africa', alpha2: 'gh', linkages: 15582 },
  '686': { name: 'Senegal', region: 'Africa', alpha2: 'sn', linkages: 14094 },
  '768': { name: 'Togo', region: 'Africa', alpha2: 'tg', linkages: 13075 },
  '72': { name: 'Botswana', region: 'Africa', alpha2: 'bw', linkages: 12768 },
  '450': { name: 'Madagascar', region: 'Africa', alpha2: 'mg', linkages: 12028 },
  '716': { name: 'Zimbabwe', region: 'Africa', alpha2: 'zw', linkages: 10925 },
  '24': { name: 'Angola', region: 'Africa', alpha2: 'ao', linkages: 10145 },
  '120': { name: 'Cameroon', region: 'Africa', alpha2: 'cm', linkages: 9788 },
  '562': { name: 'Niger', region: 'Africa', alpha2: 'ne', linkages: 9627 },
  '894': { name: 'Zambia', region: 'Africa', alpha2: 'zm', linkages: 9254 },
  '516': { name: 'Namibia', region: 'Africa', alpha2: 'na', linkages: 8401 },
  '854': { name: 'Burkina Faso', region: 'Africa', alpha2: 'bf', linkages: 7749 },
  '324': { name: 'Guinea', region: 'Africa', alpha2: 'gn', linkages: 7443 },
  '231': { name: 'Ethiopia', region: 'Africa', alpha2: 'et', linkages: 6549 },
  '434': { name: 'Libya', region: 'Africa', alpha2: 'ly', linkages: 6208 },
  '180': { name: 'DR Congo', region: 'Africa', alpha2: 'cd', linkages: 6154 },
  '508': { name: 'Mozambique', region: 'Africa', alpha2: 'mz', linkages: 5784 },
  '466': { name: 'Mali', region: 'Africa', alpha2: 'ml', linkages: 5610 },
  '454': { name: 'Malawi', region: 'Africa', alpha2: 'mw', linkages: 5016 },
  '426': { name: 'Lesotho', region: 'Africa', alpha2: 'ls', linkages: 3975 },
  '148': { name: 'Chad', region: 'Africa', alpha2: 'td', linkages: 3863 },
  '430': { name: 'Liberia', region: 'Africa', alpha2: 'lr', linkages: 3529 },
  '646': { name: 'Rwanda', region: 'Africa', alpha2: 'rw', linkages: 3131 },
  '748': { name: 'Eswatini', region: 'Africa', alpha2: 'sz', linkages: 3075 },
  '690': { name: 'Seychelles', region: 'Africa', alpha2: 'sc', linkages: 2644 },
  '694': { name: 'Sierra Leone', region: 'Africa', alpha2: 'sl', linkages: 1868 },
  '478': { name: 'Mauritania', region: 'Africa', alpha2: 'mr', linkages: 1678 },
  '108': { name: 'Burundi', region: 'Africa', alpha2: 'bi', linkages: 1445 },
  '132': { name: 'Cabo Verde', region: 'Africa', alpha2: 'cv', linkages: 1248 },
  '729': { name: 'Sudan', region: 'Africa', alpha2: 'sd', linkages: 1142 },
  '140': { name: 'Central African Republic', region: 'Africa', alpha2: 'cf', linkages: 1070 },
  '178': { name: 'Republic of Congo', region: 'Africa', alpha2: 'cg', linkages: 896 },
  '624': { name: 'Guinea-Bissau', region: 'Africa', alpha2: 'gw', linkages: 734 },
  '226': { name: 'Equatorial Guinea', region: 'Africa', alpha2: 'gq', linkages: 638 },
  '262': { name: 'Djibouti', region: 'Africa', alpha2: 'dj', linkages: 534 },
  '270': { name: 'Gambia', region: 'Africa', alpha2: 'gm', linkages: 494 },
  '706': { name: 'Somalia', region: 'Africa', alpha2: 'so', linkages: 294 },
  '232': { name: 'Eritrea', region: 'Africa', alpha2: 'er', linkages: 192 },
  '728': { name: 'South Sudan', region: 'Africa', alpha2: 'ss', linkages: 63 },
  '174': { name: 'Comoros', region: 'Africa', alpha2: 'km', linkages: 41 },
  '678': { name: 'Sao Tome and Principe', region: 'Africa', alpha2: 'st', linkages: 6 },

  // North America
  '840': { name: 'United States', region: 'North America', alpha2: 'us', linkages: 88017287 },
  '124': { name: 'Canada', region: 'North America', alpha2: 'ca', linkages: 13454575 },
  '484': { name: 'Mexico', region: 'North America', alpha2: 'mx', linkages: 2829535 },

  // Central America
  '188': { name: 'Costa Rica', region: 'Central America', alpha2: 'cr', linkages: 49674 },
  '84': { name: 'Belize', region: 'Central America', alpha2: 'bz', linkages: 4548 },
  '591': { name: 'Panama', region: 'Central America', alpha2: 'pa', linkages: 3785 },
  '222': { name: 'El Salvador', region: 'Central America', alpha2: 'sv', linkages: 846 },
  '340': { name: 'Honduras', region: 'Central America', alpha2: 'hn', linkages: 526 },
  '320': { name: 'Guatemala', region: 'Central America', alpha2: 'gt', linkages: 276 },
  '558': { name: 'Nicaragua', region: 'Central America', alpha2: 'ni', linkages: 116 },

  // Caribbean
  '214': { name: 'Dominican Republic', region: 'Caribbean', alpha2: 'do', linkages: 914196 },
  '388': { name: 'Jamaica', region: 'Caribbean', alpha2: 'jm', linkages: 4698 },
  '212': { name: 'Dominica', region: 'Caribbean', alpha2: 'dm', linkages: 169 },
  '44': { name: 'Bahamas', region: 'Caribbean', alpha2: 'bs', linkages: 126 },
  '28': { name: 'Antigua and Barbuda', region: 'Caribbean', alpha2: 'ag', linkages: 66 },
  '332': { name: 'Haiti', region: 'Caribbean', alpha2: 'ht', linkages: 59 },
  '52': { name: 'Barbados', region: 'Caribbean', alpha2: 'bb', linkages: 53 },
  '192': { name: 'Cuba', region: 'Caribbean', alpha2: 'cu', linkages: 44 },
  '659': { name: 'Saint Kitts and Nevis', region: 'Caribbean', alpha2: 'kn', linkages: 9 },
  '662': { name: 'Saint Lucia', region: 'Caribbean', alpha2: 'lc', linkages: 4 },
  '670': { name: 'Saint Vincent and the Grenadines', region: 'Caribbean', alpha2: 'vc', linkages: 1 },

  // South America
  '76': { name: 'Brazil', region: 'South America', alpha2: 'br', linkages: 23178413 },
  '218': { name: 'Ecuador', region: 'South America', alpha2: 'ec', linkages: 6798408 },
  '170': { name: 'Colombia', region: 'South America', alpha2: 'co', linkages: 2668258 },
  '152': { name: 'Chile', region: 'South America', alpha2: 'cl', linkages: 1708154 },
  '600': { name: 'Paraguay', region: 'South America', alpha2: 'py', linkages: 1537879 },
  '32': { name: 'Argentina', region: 'South America', alpha2: 'ar', linkages: 1068735 },
  '604': { name: 'Peru', region: 'South America', alpha2: 'pe', linkages: 59762 },
  '858': { name: 'Uruguay', region: 'South America', alpha2: 'uy', linkages: 4090 },
  '862': { name: 'Venezuela', region: 'South America', alpha2: 've', linkages: 4046 },
  '68': { name: 'Bolivia', region: 'South America', alpha2: 'bo', linkages: 225 },
  '328': { name: 'Guyana', region: 'South America', alpha2: 'gy', linkages: 27 },
  '740': { name: 'Suriname', region: 'South America', alpha2: 'sr', linkages: 22 },

  // Oceania
  '36': { name: 'Australia', region: 'Oceania', alpha2: 'au', linkages: 20127370 },
  '554': { name: 'New Zealand', region: 'Oceania', alpha2: 'nz', linkages: 2014824 },
  '598': { name: 'Papua New Guinea', region: 'Oceania', alpha2: 'pg', linkages: 65 },
  '242': { name: 'Fiji', region: 'Oceania', alpha2: 'fj', linkages: 51 },
  '548': { name: 'Vanuatu', region: 'Oceania', alpha2: 'vu', linkages: 15 },
  '882': { name: 'Samoa', region: 'Oceania', alpha2: 'ws', linkages: 8 },
  '90': { name: 'Solomon Islands', region: 'Oceania', alpha2: 'sb', linkages: 5 },
  '585': { name: 'Palau', region: 'Oceania', alpha2: 'pw', linkages: 3 },
  '776': { name: 'Tonga', region: 'Oceania', alpha2: 'to', linkages: 2 },
  '584': { name: 'Marshall Islands', region: 'Oceania', alpha2: 'mh', linkages: 1 },
  '520': { name: 'Nauru', region: 'Oceania', alpha2: 'nr', linkages: 1 },
};

export const DATA_FIELDS = [
  'Registration number',
  'Status',
  'VAT',
  'Address',
  'Directors / Officers',
  'Shareholders',
  'Financials',
  'Group Structure',
];

export const REGION_CONFIGS: Record<string, RegionConfig> = {
  All: { label: 'All', center: [10, 32], zoom: 1.4 },
  Asia: { label: 'Asia', center: [95, 30], zoom: 2.2 },
  Europe: { label: 'Europe', center: [18, 52], zoom: 3 },
  Africa: { label: 'Africa', center: [20, 5], zoom: 2 },
  'South America': { label: 'South America', center: [-60, -15], zoom: 2.2 },
  Caribbean: { label: 'Caribbean', center: [-72, 17], zoom: 4.5 },
  'North America': { label: 'North America', center: [-100, 45], zoom: 2 },
  'Central America': { label: 'Central America', center: [-85, 13], zoom: 4.5 },
  Oceania: { label: 'Oceania', center: [147, -25], zoom: 2.5 },
};

export const REGION_TABS = [
  'All',
  'Asia',
  'Europe',
  'Africa',
  'South America',
  'Caribbean',
  'North America',
  'Central America',
  'Oceania',
];

export const STATS: StatItem[] = [
  { value: '600', suffix: 'M+', title: 'Companies' },
  { value: '400+', suffix: '+', title: 'Government Registries' },
  { value: '200', suffix: '+', title: 'Countries' },
  { value: '24', prefix: '<', suffix: 'h', title: 'Live Registry Updates' },
];
